import { Button, Drawer, Form, Space, Input } from "antd";
import { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { BiExport } from "react-icons/bi";
import { FiDelete, FiEdit, FiPlus } from "react-icons/fi";
import { RiFilterOffLine } from "react-icons/ri";
import fetchDataRoad from "../../../../services/fetchDataRoad";
import { ExportToExcel } from "../../../../utils/exportExcel";
import formatMoney from "../../../../utils/formatMoney";
import UpdateOffer from "./UpdateOffer";
import DeleteOffer from "./DeleteOffer";
import CreateOffer from "./CreateOffer";
const { Search } = Input;
export default function PricingPanel({ isVisible, setVisible, selected }: any) {
  const [offers, setOffers] = useState<any>(selected?.offers);
  const [search, setSearch] = useState("");
  const [offer, setOffer] = useState<any>({});
  const [updateModal, setUpdateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [form] = Form.useForm();

  const handleFetchOffers = async () => {
    const uri = `offers/models/${selected?._id}`;
    if (selected?._id !== undefined) {
      const response = await fetchDataRoad({ uri });
      if (response?.success) {
        setOffers(response?.payload);
      }
    }
  };

  const getTotal = (item: any) => {
    let total = 0;
    total = item?.partsrate + item?.labourrate * item?.flattime;
    return isNaN(total) ? 0 : total;
  };

  useEffect(() => {
    handleFetchOffers();
  }, [selected]);

  console.log(selected);

  const handleClearSearch = () => {
    setSearch("");
    form.resetFields();
  };

  return (
    <Drawer
      title={`PRICING : ${selected?.name}`}
      placement={"right"}
      width={1000}
      onClose={() => setVisible(!isVisible)}
      visible={isVisible}
      closable={false}
      extra={
        <Space>
          <Button
            type="default"
            color="#E50000"
            onClick={() => setVisible(!isVisible)}
            danger
          >
            <AiOutlineClose />
          </Button>
        </Space>
      }
    >
      <div className="font-toyota">
        <div className="p-2 bg-gray-200 font-bold -mt-6 border-b border-t border-gray-300">
          <div className="flex justify-between items-center">
            <span className="text-green-600 mr-1">{selected?.name} :</span>
            Service pricing
            <Button onClick={() => setCreateModal(true)}>
              <FiPlus />
            </Button>
          </div>
        </div>
        <div className="flex justify-between items-center border-b border-gray-300 pb-2 mt-2">
          <div className="flex">
            <Form layout="inline" form={form}>
              <Form.Item name="registration">
                <Search
                  placeholder="Search by description"
                  allowClear
                  onChange={(val: any) => {
                    setSearch(val.target.value);
                  }}
                  onSearch={(value: any) => {
                    setSearch(value);
                  }}
                />
              </Form.Item>

              <Button className="" onClick={() => handleClearSearch()}>
                <RiFilterOffLine color="#6b7280" />
              </Button>
            </Form>
          </div>
          <div className="flex ">
            <button
              color="#E50000"
              className="flex justify-center items-center border p-1 hover:bg-green-100"
            >
              <BiExport size={24} />
              <span
                className="ml-2"
                onClick={() =>
                  ExportToExcel(
                    offers?.map((record: any, index: number) => {
                      return {
                        "S/N": index + 1,
                        "Call out description": record?.callout_desc || "-",
                        "Invoice Description": record?.invoice_desc || "-",
                        Model: selected?.name || "-",
                        "Total (VAT exc)": formatMoney(getTotal(record)),
                        "Total (VAT inc)": formatMoney(getTotal(record) * 1.18),
                      };
                    }),
                    "Offers.xlsx"
                  )
                }
              >
                Export To Excel
              </span>
            </button>
          </div>
        </div>

        <div className="grid grid-cols-12 font-bold  py-3 border-b border-t border-gray-300">
          <div className="col-span-12 sm:col-span-4 truncate  flex">
            <div className="w-10">S/N.</div>
            Call out Description
          </div>
          <div className="col-span-12 sm:col-span-3 truncate text-left ">
            Invoice Description
          </div>
          <div className="col-span-12 sm:col-span-2 truncate flex justify-end px-2">
            Total (VAT exc)
          </div>
          <div className="col-span-12 sm:col-span-2 truncate flex justify-end px-2">
            Total (VAT inc)
          </div>
          <div className="col-span-12 sm:col-span-1">
            <div className="truncate flex-1 text-left">Actions</div>
          </div>
        </div>
        {offers
          ?.filter((offer: any) => offer?.callout_desc?.includes(search))
          ?.map((item: any, index: number) => (
            <div
              className="grid grid-cols-12 py-1 border-b border-gray-300"
              key={index}
            >
              <div className="col-span-12 sm:col-span-4 flex">
                <div className="w-10">{index + 1}</div>
                {item?.callout_desc === null ? "-" : item?.callout_desc}
              </div>
              <div className="col-span-12 sm:col-span-3  truncate">
                {item?.invoice_desc === null ? "-" : item?.invoice_desc}
              </div>

              <div className="col-span-12 sm:col-span-2 truncate flex justify-end px-2">
                {formatMoney(getTotal(item))}
              </div>
              <div className="col-span-12 sm:col-span-2 truncate flex justify-end px-2">
                {formatMoney(getTotal(item) * 1.18)}
              </div>
              <div className="col-span-12 sm:col-span-1">
                <div className="flex">
                  <div className="truncate flex justify-end">
                    <div className="flex justify-start">
                        <button
                          onClick={() => {
                            setOffer({
                              ...item,
                            });
                            setUpdateModal(true);
                          }}
                          className="flex justify-center items-center text-yellow-700 border rounded-md p-2 bg-yellow-100 hover:bg-yellow-200 cursor-pointer"
                        >
                          <FiEdit />
                        </button>
                        <button
                          onClick={() => {
                            setOffer({
                              ...item,
                            });
                          setDeleteModal(true);
                        }}
                        className="flex justify-center items-center text-red-700 border rounded-md p-2 bg-red-100 hover:bg-red-200 cursor-pointer ml-2"
                      >
                        <FiDelete />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        <UpdateOffer
          isVisible={updateModal}
          setVisible={setUpdateModal}
          selected={selected}
          offer={offer}
          refetch={handleFetchOffers}
        />

        <DeleteOffer
          isVisible={deleteModal}
          setVisible={setDeleteModal}
          selected={selected}
          offer={offer}
          refetch={handleFetchOffers}
        />

        <CreateOffer
          isVisible={createModal}
          setVisible={setCreateModal}
          selected={selected}
          refetch={handleFetchOffers}
        />
      </div>
    </Drawer>
  );
}
